
  import ProjectRow from "./ProjectRow.vue";

  export default {
    name: "ProjectsList",
    components: { ProjectRow },
    props: {
      projects: Array, // List of project core
      state: String // project filter state (active, closed, deleted)
    },
    data() {
      return {
        text: {
          project: this.$tc("project", 1),
          contacts: this.$t("contacts"),
          client: this.$tc("client", 1),
          start: this.$t("start"),
          end: this.$t("end"),
          closing: this.$t("closing"),
          projectType: this.$t("projectType"),
          thereAreNoProjects: this.$t("thereAreNoProjects")
        }
      };
    }
  };
